import axios, { AxiosError, AxiosResponse } from "axios";

interface CustomError extends Error {
  response?: AxiosResponse;
}

export const mandateCheck = async (url: string) => {
  let attempts = 0;

  while (attempts < 6) {
    try {
      const response = await axios.get(url);
      const responseData = response.data;

      if (
        responseData.MandateProcessed === true &&
        responseData.MandateAccepted === true
      ) {
        return true;
      }

      attempts++;
      await new Promise((resolve) => setTimeout(resolve, 5000));
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const customError: CustomError = error;
        if (attempts === 24 - 1) {
          throw new Error(
            `API did not return the required response after ${32} attempts.`
          );
        }

        console.error("Error calling the API:", customError.message);
        attempts++;
        await new Promise((resolve) => setTimeout(resolve, 10000));
      } else {
        console.error("Unknown error occurred:", error);
        throw new Error(`Unknown error occurred.`);
      }
    }
  }

  return false;
};
